import { hasLength } from "./HelperFunction";
import { buildFilterClause, selectedPayrollTypeFilter } from "./payrollFilterHelpers";

export function getSelectFilterPlan(field, value, setups, currentFilter, payrollType) {
  const plans = {
    payrollTypes: () => getPayrollTypesFilterPlan(value, currentFilter),
    employmentType: () => getEmploymentTypeFilterPlan(value, payrollType, currentFilter),
    payItems: () => getPayItemsFilterPlan(value, setups, currentFilter),
  };

  return plans[field]?.() ?? null;
}

export function getPayrollTypesFilterPlan(value, currentFilter) {
  if (!hasLength(value)) {
    return {};
  }

  if (value.shouldClearFilters && value.useConditionalFilters) {
    return {
      nextFilters: { seperationType: { seperationType: { $ne: "Resigned" } } },
    };
  }

  if (value.shouldClearFilters) {
    return {};
  }

  return {
    nextFilters: {
      payrollType: buildFilterClause("Relation", value, "payrollType", currentFilter),
    },
  };
}

export function getEmploymentTypeFilterPlan(value, payrollType, currentFilter) {
  const payrollTypeFilter = selectedPayrollTypeFilter(payrollType);
  const isJobOrder = hasLength(value) && value.name?.toLowerCase() === "job order";
  const nextFilters = {};

  if (hasLength(value)) {
    nextFilters.employmentType = buildFilterClause(
      "Pointer",
      value,
      "employmentType",
      currentFilter
    );
  }
  if (payrollTypeFilter && !isJobOrder) {
    nextFilters.payrollType = payrollTypeFilter;
  }

  return { nextFilters, preserveKeys: ["seperationType"] };
}

export function getPayItemsFilterPlan(value, setups, currentFilter) {
  const sharedPreserve = ["payrollType", "employmentType", "seperationType"];

  if (setups?.category === "JO") {
    return { preserveKeys: ["employmentType"] };
  }

  if (!hasLength(value)) {
    return { preserveKeys: sharedPreserve };
  }

  if (setups?.isSelected) {
    return {
      nextFilters:
        setups?.category === "BASIC"
          ? {
              suspension: buildFilterClause(
                "BooleanNotTrue",
                true,
                "suspension",
                currentFilter
              ),
            }
          : {},
      preserveKeys: ["employmentType", "seperationType"],
    };
  }

  const nextFilters = {
    payItem: buildFilterClause("Relation", value, "payItem", currentFilter),
  };

  if (setups?.category === "BASIC") {
    nextFilters.suspension = buildFilterClause(
      "BooleanNotTrue",
      true,
      "suspension",
      currentFilter
    );
  }

  return { nextFilters, preserveKeys: sharedPreserve };
}
